import { render, staticRenderFns } from "./token-use-guideline.vue?vue&type=template&id=c33d4104&"
import script from "./token-use-guideline.vue?vue&type=script&lang=js&"
export * from "./token-use-guideline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports